import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {UnitsOfTimeType} from "../../../commons/types/units-of-time.type";

export class ProgramServiceTimeViewComponent implements IController {
  program: any;
  groups: any;
  programId: any;
  accountId: any;
  isShowFieldServiceCard: boolean;
  isShowAllowedWaitingCard: boolean;

  public isSaveAvailable: any;
  public groupKeys: any;
  public groupKeysCopy: any;
  public unitsOfTimeType: typeof UnitsOfTimeType = UnitsOfTimeType;
  public isDesktop: boolean;


  constructor(private PricePlanService, private $mdMedia) {
  }

  $onInit() {
    this.isDesktop = this.$mdMedia('gt-md');
    this.setGroupKeys();
  }

  onDataChange(groupKeys) {
    this.dataChange(groupKeys);
  }

  onServiceTimeValueChange(value, field) {
    field.value = value;
    this.onDataChange(this.groupKeys);
  }

  onSaveProgram() {
    const updatedProgram = this.PricePlanService.generatePreferencesDataPayload(this.program, this.groupKeys);
    this.PricePlanService.saveProgramDataByGroups(this.programId, updatedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        this.program = updatedProgram;
      })
      .catch(() => {

      })
      .finally(() => {
        this.setGroupKeys();
      })
  }

  onCancelChanges() {
    this.groupKeys = angular.copy(this.groupKeysCopy);
  }


  // ******************************
  //        Private methods
  // ******************************

  private setGroupKeys() {
    this.isSaveAvailable = false;
    this.groupKeys = this.PricePlanService.generatePreferencesDataGroupKeys(this.program.data);
    this.groupKeysCopy = angular.copy(this.groupKeys);
  }

  private dataChange(groupKeys) {
    this.isSaveAvailable = !_.isEqual(groupKeys, this.groupKeysCopy);
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programServiceTimeView', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      accountId: '<?',
      isShowFieldServiceCard: '<?',
      isShowAllowedWaitingCard: '<?'
    },
    template: require('./program-service-time-view.html').default,
    controller: ProgramServiceTimeViewComponent
  });
